import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { useAuth, useToast } from '../hooks/Hooks';
import { RemuneracaoService } from '../../fe-api/services/RemuneracaoService';

const Remuneracao: React.FC = () => {

    const { session } = useAuth();
    const { showError } = useToast();
    
    // Mudamos o loading para guardar o ID da verba que está sendo baixada
    const [loadingVerba, setLoadingVerba] = useState<number | null>(null);

    const remuneracaoService = new RemuneracaoService();

    // 1. Funções de data mantidas
    const getCompetenciaAnteriorExtenso = () => {
        const data = new Date();
        data.setMonth(data.getMonth() - 1);
        const mes = data.toLocaleString('pt-BR', { month: 'long' });
        const ano = data.getFullYear();
        return `${mes.charAt(0).toUpperCase() + mes.slice(1)}/${ano}`;
    };

    const getCompetenciaAnterior = () => {
        const data = new Date();
        data.setMonth(data.getMonth() - 1);
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        return `${mes}/${ano}`;
    };

    // 2. Lista estruturada com os 4 tipos de documentos exigidos
    const documentosDisponiveis = [
        { 
            id: 1, 
            titulo: 'Subsídio' 
        },
        { 
            id: 2, 
            titulo: 'Verbas relativas ao exercício de função comissionada, recebidas do Tesouro e de acordo com legislação aplicável a todo o Executivo Estadual' 
        },
        { 
            id: 3, 
            titulo: 'Verbas indenizatórias eventuais do Fundo da PGE' 
        },
        { 
            id: 4, 
            titulo: 'Verbas indenizatórias mensais do Fundo da PGE' 
        }
    ];

    // 3. Função de Download
    const handleDownload = async (tipoVerba: number) => {
        const competencia = getCompetenciaAnterior();
        
        try {
            setLoadingVerba(tipoVerba);
            
            const { blob, filename } = await remuneracaoService.downloadPdf(competencia, tipoVerba);

            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

        } catch (error: any) {
            if (error.status === 404 || error?.response?.status === 404 || error.message.includes("Nenhum documento encontrado")) {
                showError('Documento Indisponível', `O arquivo referente a ${competencia} para este tipo de verba ainda não foi publicado.`);
            } else {
                showError('Falha no Download', error.message || 'Ocorreu um erro ao tentar baixar o arquivo.');
            }
        } finally {
            setLoadingVerba(null);
        }
    };

    return (
        <div className="p-4">
            
            {/* CABEÇALHO */}
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center mb-4 gap-3">
                <div>
                    <h2 className="text-2xl font-bold m-0 text-900">Remuneração</h2>
                    <p className="text-600 mt-2 mb-0">
                        Consulte os valores referentes à competência vigente baixando os demonstrativos abaixo.
                    </p>
                </div>
                
                <div className="surface-100 p-2 border-round text-700 font-medium flex align-items-center">
                    <i className="pi pi-calendar mr-2 text-primary"></i>
                    Competência: {getCompetenciaAnteriorExtenso()}
                </div>
            </div>

            {/* LISTA DE ARQUIVOS PARA DOWNLOAD (Movido para cima) */}
            <div className="card mb-5">
                <h3 className="text-xl font-semibold mb-4 text-900">Arquivos Disponíveis</h3>
                
                <div className="flex flex-column gap-3">
                    {documentosDisponiveis.map((doc) => (
                        <div 
                            key={doc.id} 
                            className="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center p-3 border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150"
                        >
                            <div className="flex align-items-center mb-3 md:mb-0">
                                <i className="pi pi-file-pdf text-red-500 text-2xl mr-3"></i>
                                <span className="text-700 font-medium line-height-3">{doc.titulo}</span> &nbsp;&nbsp;&nbsp;
                            </div>
                            
                            <Button 
                                label="Baixar PDF" 
                                icon="pi pi-download" 
                                className="p-button-outlined p-button-primary white-space-nowrap" 
                                onClick={() => handleDownload(doc.id)}
                                loading={loadingVerba === doc.id}
                                disabled={loadingVerba !== null && loadingVerba !== doc.id}
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* AVISO INSTITUCIONAL DE RASTREABILIDADE (Movido para baixo) */}
            <div className="surface-ground border-left-3 border-orange-500 p-4 border-round">
                <div className="flex align-items-center mb-2">
                    <i className="pi pi-exclamation-triangle text-orange-500 text-xl mr-2"></i>
                    <h3 className="m-0 text-lg font-semibold text-900">Aviso de Rastreabilidade</h3>
                </div>
                <p className="m-0 text-700 line-height-3 text-justify">
                    Os acessos e downloads realizados neste módulo são registrados para fins de auditoria, 
                    segurança da informação e rastreabilidade institucional, em conformidade com o art. 31, 
                    § 2.º, da Lei 12.527/2011 e os princípios da Lei 13.709/2018 (LGPD). O documento baixado 
                    conterá seu CPF e dados de acesso incorporados como marca d'água e rodapé.
                </p>
            </div>

        </div>
    );
}

export default Remuneracao;